import { isArray, isObject } from "lodash";

const mainSeriesTypeName = "MainSeries";

const getChartPanes = chartData => {
  const candidates = [
    chartData?.charts?.[0]?.panes,
    chartData?.chart?.charts?.[0]?.panes
  ];

  return candidates.find(isArray);
};

const getMainSeries = chartData => {
  const chartPanes = getChartPanes(chartData);

  if (!isArray(chartPanes)) return;

  const paneWithMainSeries = chartPanes.find(({ sources }) => {
    if (!isArray(sources)) return false;

    const mainSeries = sources.find(({ type }) => type === mainSeriesTypeName);
    return isObject(mainSeries);
  });

  if (!isArray(paneWithMainSeries?.sources)) return;

  return paneWithMainSeries.sources.find(
    ({ type }) => type === mainSeriesTypeName
  );
};

export default getMainSeries;
